// src/pages/Benefits.jsx
import React from "react";
import { useLangTranslation } from "../utils/translation";

export default function Benefits() {
  // 공용 번역 훅 사용
  const t = useLangTranslation('benefits');

  const benefits = [
    { key: 'flexible' },
    { key: 'equipment' },
    { key: 'incentive' },
    { key: 'workshop' },
    { key: 'refresh' },
    { key: 'health' },
    { key: 'celebrations' },
    { key: 'family' },
    { key: 'wellbeingCard' },
    { key: 'aiTools' },
  ];

  return (
    <section className="benefits-section">
      {/* Hero 섹션 */}
      <div className="benefits-hero">
        <div className="benefits-hero-content">
          <h1 className="benefits-title">{t('hero.title')}</h1>
          <p className="benefits-subtitle">{t('hero.subtitle')}</p>
          <p className="benefits-tagline">{t('hero.tagline')}</p>
        </div>
      </div>

      {/* 본문 섹션 */}
      <div className="benefits-content">
        {/* 인용구 */}
        <div className="benefits-quote-section">
          <blockquote className="benefits-quote" dangerouslySetInnerHTML={{ __html: t('quote.text') }} />
        </div>

        {/* 복리후생 리스트 */}
        <div className="benefits-list">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <span className="benefit-icon">{String(index + 1).padStart(2, '0')}</span>
              <p className="benefit-text">{t(`benefits.${benefit.key}`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

